<div class="tw-py-[16px] {{ addCSS }}">
  <h3
    class="tw-font-inter tw-text-[23px] tw-font-bold tw-text-white {{
      !description ? 'tw-mb-[20px]' : ''
    }}"
  >
    {{ sectionTitle }}
  </h3>
  @if (description) {
  <p class="tw-py-[10px] tw-font-inter tw-text-[10px] tw-text-white">
    {{ description }}
  </p>
  }
  <ng-content></ng-content>
</div>
